module.exports = __webpack_public_path__ + "static/media/w (41).26c659df.jpg";